// John Eldhose 20200610
import React, { Component } from 'react';
import { Divider, Typography } from '@material-ui/core';

class ShowStatus extends Component {
  render() {
    if(this.props.status === 'failed')
      return (
        <div>
          <Typography variant='display1'>
            <font color='#385687'>Failed to Send</font>
          </Typography>
          <div style={{ padding: '70px' }}>
            <Typography variant='body1' style={{ textAlign: 'justify' }}>
              Failed to send the information requested. Please contact us at one of the following contacts:
            </Typography>
            <br />
            <Typography variant='body1'>
              Email: <a href='mailto:demo_request@carlsonsw.com'>Demo Request Contact</a><br />
              Phone: 606-564-5028<br />
              Fax: 606-564-6422
            </Typography>
          </div>
          <Divider style={{ margin: '10px 0px' }} />
          <Typography variant='body1'>
            Return to the <a href="https://www.carlsonsw.com">Carlson Website</a>
          </Typography>
        </div>
      );
    else if(this.props.status === 'thankyou')
      return (
        <div>
          <Typography variant='display1'>
            <font color='#385687'>Thank You</font>
          </Typography>
          <div style={{ padding: '70px' }}>
            <Typography variant='body1' style={{ textAlign: 'justify' }}>
              Thank you for your interest in Carlson Software. Your information has been submitted.<br />
              If you do not receive correspondence from your request soon, please contact us at one of the following contacts:<br />
            </Typography>
            <br />
            <Typography variant='body1'>
              Email: <a href='mailto:demo_request@carlsonsw.com'>Demo Request Contact</a><br />
              Phone: 606-564-5028<br />
              Fax: 606-564-6422
            </Typography>
          </div>
          <Divider style={{ margin: '10px 0px' }} />
          <Typography variant='body1'>
            Return to the <a href="https://www.carlsonsw.com">Carlson Website</a>
          </Typography>
        </div>
      );
  }
}

export default ShowStatus;



// WEBPACK FOOTER //
// ./src/components/lib/ShowStatus.js